import FormDrawer from './FormDrawer';

export default class TimezoneDrawer extends FormDrawer {
  private $drawerOptions: HTMLElement;
  private $submitButton: HTMLButtonElement;
  private $searchInput: HTMLInputElement;
  private $select: HTMLSelectElement;
  private $input: HTMLInputElement;

  private selectedOption: { label: string, value: string, $element: HTMLElement } | undefined = undefined;
  private options: { label: string, value: string, $element: HTMLElement }[] = [];

  constructor($toggle: HTMLElement, $drawer: HTMLElement, $select: HTMLSelectElement) {
    super($toggle, $drawer);

    this.$drawerOptions = this.$drawer.querySelector('.tc-form-drawer__options');
    this.$submitButton = this.$drawer.querySelector('.tc-form-drawer__submit');
    this.$searchInput = this.$drawer.querySelector('.tc-form-drawer__search');
    this.$select = $select;
    this.$input = document.querySelector('.tc-shipment-timezone');

    [].slice.call($select.querySelectorAll('option')).forEach(($option: HTMLOptionElement) => {
      const $element = document.createElement('div');

      $element.classList.add('tc-form-drawer__option');
      $element.innerText = $option.innerText;

      this.$drawerOptions.appendChild($element);

      $element.addEventListener('click', (event) => this.onOptionClicked(event));

      const option = {
        $element,
        label: $option.innerText,
        value: $option.value,
      };

      this.options.push(option);

      if ($option.selected) {
        this.selectedOption = option;
      }
    });

    this.$submitButton.addEventListener('click', (event) => this.onSubmitClicked(event));
    this.$searchInput.addEventListener('keyup', () => this.onSearch());
    this.$select.addEventListener('change', () => this.onSelectChange());

    this.$input.value = this.$select.value;

    if (this.selectedOption) {
      this.$toggle.innerText = this.selectedOption.label;
    }
  }

  public onToggleClicked(event?): void {
    super.onToggleClicked(event);

    this.options.forEach((option) => {
      option.$element.classList.remove('is-active');
    });

    if (this.$input.value.length) {
      this.selectedOption = this.options.find((option) => option.value == this.$input.value);
      this.selectedOption.$element.classList.add('is-active');
    }
  }

  protected onCloseButtonClicked(event): void {
    super.onCloseButtonClicked(event);

    this.$searchInput.value = '';
  }

  private onSubmitClicked(event): void {
    event.preventDefault();

    if (this.selectedOption) {
      this.$toggle.innerText = this.selectedOption.label;
      this.$input.value = this.selectedOption.value;

      this.$select.value = this.$input.value;
      this.$select.dispatchEvent(new Event('change'));
      document.querySelector('.tc-shipment-timezone__select .filter-option-inner-inner').innerHTML = this.selectedOption.label;

      this.$drawer.style.display = 'none';
    }
  }

  private onSearch(): void {
    const searchQuery = this.$searchInput.value.toLowerCase();

    this.options.forEach((option) => {
      if (!option.label.toLowerCase().startsWith(searchQuery)) {
        option.$element.style.display = 'none';
      } else {
        option.$element.style.display = 'block';
      }
    });
  }

  private onOptionClicked(event): void {
    event.preventDefault();

    const $target = event.target as HTMLElement;

    if (this.selectedOption) {
      this.selectedOption.$element.classList.remove('is-active');
    }

    this.selectedOption = this.options.find((option) => option.label === $target.innerText);

    this.selectedOption.$element.classList.add('is-active');
  }

  private onSelectChange(): void {
    this.$input.value = this.$select.value;
    this.$toggle.innerText = this.options.find((option) => option.value === this.$input.value).label;
  }
}
